import { Trans } from 'react-i18next';
import TefconIcon1 from '../../assets/tefcon_icon_1.svg';
import TefconIcon2 from '../../assets/tefcon_icon_2.svg';
import TefconIcon3 from '../../assets/tefcon_icon_3.svg';
import TefconIcon4 from '../../assets/tefcon_icon_4.svg';
import TefconIcon5 from '../../assets/tefcon_icon_5.svg';
import TefconIcon6 from '../../assets/tefcon_icon_6.svg';
import TeflonSection2Image1 from '../../assets/teflon_section2_image1.png';
import TeflonSection2Image3 from '../../assets/teflon_section2_image3.png';
import TeflonSection2Image4 from '../../assets/teflon_section2_image4.png';
import TeflonSection2Image5 from '../../assets/teflon_section2_image5.png';
import TeflonSection2Image6 from '../../assets/teflon_section2_image6.png';
import { CenterLayout, HorizontalEqualLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, Body3, H4, H7, H9, Text3, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const TeflonCoatingSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);
  const isKor = ['ko', 'ko-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(166)}`} />
      {isMobile ? (
        <>
          <CenterLayout>
            <H4 style={{ textAlign: isMobile ? 'center' : 'left' }}><Trans i18nKey='붙지 않고, 녹슬지 않게. 비비테크의 고성능 테프론 코팅 기술' /></H4>
          </CenterLayout>
        </>
      ) : (
        <>
          <H4 style={{ textAlign: isMobile ? 'center' : 'left' }}><Trans i18nKey='붙지 않고, 녹슬지 않게. 비비테크의 고성능 테프론 코팅 기술' /></H4>
        </>
      )}
      <BTBox height={isMobile ? 24 : `${pxToRem(50)}`} />
      {isMobile ? (
        <img src={TeflonSection2Image1} style={{
          width: '100%', height: '400px', objectFit: 'cover',
          objectPosition: '10% center',
        }} />
      ) : (
        <img src={TeflonSection2Image1} style={{ width: '100%' }} />
      )}
      <BTBox height={isMobile ? 60 : `${pxToRem(81)}`} />
      <CenterLayout>
        {isMobile ? <H4><Trans i18nKey='공정에 최적화된 맞춤형 설계' /></H4> : <H7><Trans i18nKey='공정에 최적화된 맞춤형 설계' /></H7>}
      </CenterLayout>
      <BTBox height={isMobile ? 8 : pxToRem(30)} />
      <CenterLayout>
        <Body1 style={{ opacity: isMobile ? '1' : '0.5' }}><Trans i18nKey='코팅 두께, 재질, 적용 방식까지 고객의 공정 조건에 맞춰 설계하며, 정밀하고 균일한 품질로 제품의 신뢰성과 수명을 극대화합니다.' /></Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : pxToRem(68)} />

      <HorizontalEqualLayout
        gap={isMobile ? 8 : 40}
        style={{
          width: '100%',
          flexDirection: isMobile ? 'column' : 'row'
        }}
      >
        <VerticalLayout style={{ flex: 1 }}>
          <img src={TeflonSection2Image5} style={{ width: '100%' }} />
        </VerticalLayout>
        <VerticalLayout style={{ flex: 1 }}>
          <img src={TeflonSection2Image6} style={{ width: '100%' }} />
        </VerticalLayout>
      </HorizontalEqualLayout>

      <BTBox height={pxToRem(122)} />

      {isMobile ? (
        <VerticalLayout>
          <BTBox width={60} />
          <VerticalLayout>
            <VerticalLayout>
              <CenterLayout>
                <img src={TeflonSection2Image3} style={{ width: '100%' }} />
              </CenterLayout>
              <CenterLayout>
                <H7><Trans i18nKey='FM 인증을 획득한 정전도장 방식' /></H7>
              </CenterLayout>
              <BTBox width={16} />
              <CenterLayout>
                <Text4><Trans i18nKey='불소수지 분말을 활용한 정전도장 방식으로 파이프 및 덕트 내부를 코팅하여, 내화성과 내식성이 뛰어난 제품을 생산합니다.'></Trans></Text4>
              </CenterLayout>
              <BTBox height={40} />
              <div style={{ width: '100%', height: '0.5px', backgroundColor: 'black', opacity: 0.4 }} />
              <BTBox height={40} />
              <CenterLayout>
                <img src={TeflonSection2Image4} style={{ width: '100%' }} />
              </CenterLayout>
            </VerticalLayout>
            <BTBox height={18} />
            <CenterLayout>
              <H9 style={{
                ...isMobile ? { fontWeight: 700 } : {}
              }}>FM TEFLON COATING DUCT : BBFLON Duct</H9>
            </CenterLayout>
          </VerticalLayout>
        </VerticalLayout>
      ) : (

        <HorizontalEqualLayout
          gap={40}
          style={{
            width: '100%',
            alignItems: 'start'
          }}
        >
          <VerticalLayout style={{ flex: 1, alignItems: 'center' }}>
            <img src={TeflonSection2Image3} style={{ width: '100%' }} />
            <BTBox height={pxToRem(40)} />
            <H7 style={{ textAlign: 'center' }}>
              <Trans i18nKey='FM 인증을 획득한 정전도장 방식' />
            </H7>
            <BTBox height={pxToRem(16)} />
            <Text4 style={{ textAlign: 'center', opacity: 0.5 }}>
              <Trans i18nKey='불소수지 분말을 활용한 정전도장 방식으로 파이프 및 덕트 내부를 코팅하여, 내화성과 내식성이 뛰어난 제품을 생산합니다.' />
            </Text4>
          </VerticalLayout>
          <VerticalLayout style={{ flex: 1, alignContent: 'start' }}>
            <img src={TeflonSection2Image4} style={{ width: '100%' }} />
            <BTBox height={pxToRem(40)} />
            <CenterLayout>
              <H7 style={{ textAlign: 'center' }}>
                FM TEFLON COATING DUCT - <br />BBFLON Duct
              </H7>
            </CenterLayout>
          </VerticalLayout>
        </HorizontalEqualLayout>
      )}

      <BTBox height={isMobile ? 91 : `${pxToRem(166)}`} />

      {isMobile ? (
        <>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            <BTBox height={32} />
            <img src={TefconIcon1} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='내화학성' /></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='고농도의 산·알카리부터 유기용제까지, 어떤 화학물질에도 강한 비비테크의 테프론 코팅은 설비의 수명과 공정의 안정성을 지켜줍니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='· 강한 산·알카리에 이상 無' /></Text3>
            </div>
            <BTBox height={54} />
          </VerticalLayout>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            <BTBox height={32} />
            <img src={TefconIcon2} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='비점착성'/></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 이물질이 표면에 달라붙지 않아 세척이 용이하고, 공정의 효율성과 위생까지 높여줍니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='· 오염 방지' /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='· 세정 및 유지보수 용이' /></Text3>
            </div>
            <BTBox height={54} />
          </VerticalLayout>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            <BTBox height={32} />
            <img src={TefconIcon3} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='정전기방지'/></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 높은 절연성과 정전기 방지 기능으로 민감한 생산 환경에서도 안전성과 제품 품질을 모두 지켜냅니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='· 높은 절연성, 낮은 손실률' /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='· 정전기 방지 가능' /></Text3>
            </div>
            <BTBox height={54} />
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
          </VerticalLayout>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <BTBox height={32} />
            <img src={TefconIcon4} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='비유성' /></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론을 코팅한 표면은 물이나 기름이 잘 묻지 않기 때문에 청소가 용이하며 많은 경우 자동적으로 청결이 유지됩니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='ㆍ탁월한 오염 방지 기능' /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='ㆍ세척이 간편하고 위생적' /></Text3>
            </div>
            <BTBox height={54} />
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
          </VerticalLayout>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <BTBox height={32} />
            <img src={TefconIcon5} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='내열성' /></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 최고 290℃의 온도까지 연속사용이 가능하며, 성능저하 없이 안정적인 작업을 가능하게 합니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='ㆍ열에 의한 박리, 변색, 연화 현상 없음' /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='ㆍ290℃의 고온에서도 안정적인 성능 유지' /></Text3>
            </div>
            <BTBox height={54} />
            <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
          </VerticalLayout>
          <VerticalLayout style={{ alignItems: 'center' }}>
            <BTBox height={32} />
            <img src={TefconIcon6} />
            <BTBox height={10} />
            <Body3><Trans i18nKey='저마찰계수' /></Body3>
            <BTBox height={7} />
            <div style={{ paddingLeft: isKor ? '47px' : '0px', paddingRight: isKor ? '47px' : '0px' }}>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론의 마찰계수는 부하, 미끄러지는 속도, 사용된 테프론 코팅 종류에 따라 다르나 일반적으로 0.05~0.2정도입니다.' /></Text3>
              <Text3><br /></Text3>
              <Text3 style={{ opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='ㆍ고속ㆍ정밀 구동이 필요한 장비에 최적' /></Text3>
            </div>
          </VerticalLayout>
        </>
      ) : (
        <>
          <HorizontalEqualLayout gap={68} style={{ alignItems: 'start' }}>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon1} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='내화학성' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='고농도의 산·알카리부터 유기용제까지, 어떤 화학물질에도 강한 비비테크의 테프론 코팅은 설비의 수명과 공정의 안정성을 지켜줍니다.' /><br /><br /><Trans i18nKey='· 강한 산·알카리에 이상 無' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon2} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='비점착성' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 이물질이 표면에 달라붙지 않아 세척이 용이하고, 공정의 효율성과 위생까지 높여줍니다.' /><br /><br /><Trans i18nKey='· 오염 방지' /><br /><Trans i18nKey='· 세정 및 유지보수 용이' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon3} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='정전기방지' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 높은 절연성과 정전기 방지 기능으로 민감한 생산 환경에서도 안전성과 제품 품질을 모두 지켜냅니다.' /><br /><br /><Trans i18nKey='· 높은 절연성, 낮은 손실률' /><br /><Trans i18nKey='· 정전기 방지 가능' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
          </HorizontalEqualLayout>

          <BTBox height={80} />

          <HorizontalEqualLayout gap={68} style={{ alignItems: 'start' }}>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon4} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='비유성' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론을 코팅한 표면은 물이나 기름이 잘 묻지 않기 때문에 청소가 용이하며 많은 경우 자동적으로 청결이 유지됩니다.' /><br /><br /><Trans i18nKey='ㆍ탁월한 오염 방지 기능' /><br /><Trans i18nKey='ㆍ세척이 간편하고 위생적' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon5} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='내열성' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론 코팅은 최고 290℃의 온도까지 연속사용이 가능하며, 성능저하 없이 안정적인 작업을 가능하게 합니다.' /><br /><br /><Trans i18nKey='ㆍ열에 의한 박리, 변색, 연화 현상 없음' /><br /><Trans i18nKey='ㆍ290℃의 고온에서도 안정적인 성능 유지' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
            <VerticalLayout style={{ alignItems: 'center' }}>
              <BTBox height={`${pxToRem(32)}`} />
              <img src={TefconIcon6} />
              <BTBox height={5} />
              <Body3><Trans i18nKey='저마찰계수' /></Body3>
              <BTBox height={30} />
              <div style={{ paddingLeft: '47px', paddingRight: '47px' }}>
                <Text3 style={{ height: `${pxToRem(isEng ? 330 : 216)}`, opacity: '0.5', textAlign: 'center' }}><Trans i18nKey='테프론의 마찰계수는 부하, 미끄러지는 속도, 사용된 테프론 코팅 종류에 따라 다르나 일반적으로 0.05~0.2정도입니다.' /><br /><br /><Trans i18nKey='ㆍ고속ㆍ정밀 구동이 필요한 장비에 최적' /></Text3>
              </div>
              <BTBox height={`${pxToRem(90)}`} />
              <VerticalLayout height={1} backgroundColor='black' style={{ opacity: '0.2' }} />
            </VerticalLayout>
          </HorizontalEqualLayout>
        </>
      )}

      <BTBox height={isMobile ? 139 : pxToRem(461)} />
    </VerticalLayout>
  );
};

export default TeflonCoatingSection2;
